import BlockSelector from "./BlockSelector";
import BlockEditor from "./BlockEditors";
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "reactstrap";
import { useState } from "react";
import StyleSelect from "../StyleSelect/StyleSelect";
import "./style.scss";

export default function Block({
  block,
  index,
  isFirst,
  isLast,
  onMoveUp,
  onMoveDown,
  onChangeType,
  onChangeData,
  onChangeStyles,
  onDelete,
  blockCount,
  hasError,
  editable
}) {
  const blockId = block.id;
  const [open, setOpen] = useState(block.autoOpen ? block.id : "");
  
  function toggle(id) {
    setOpen(open === id ? "" : id);
  };
  
  
  return (
    <>
        {!block.type ? (
          <div className="block mb-3">
            <div className="block-content">
              <BlockSelector onSelect={onChangeType} />
            </div>
          </div>
        ) : (
          <Accordion open={open} toggle={toggle} className={`mb-3 block-accordion ${hasError ? "accordion-error" : ""}`}>
            <AccordionItem>
              <AccordionHeader targetId={blockId} className="block-accordion__header">
                <div className="block-accordion__header__wrap">
                    <p className="block-accordion__header__text">
                        Content
                    </p>
                  <div className="btn-group">
                    <div
                        className="block-style"
                        onClick={(e) => e.stopPropagation()}
                        onMouseDown={(e) => e.stopPropagation()}
                        >
                        <StyleSelect
                            value={block.style}
                            onChange={onChangeStyles}
                            style={{width: '270px'}}
                            editable={editable}
                        />
                    </div>
                        {
                          !editable && (
                            <>
                              
                                {
                                    blockCount > 1 && (
                                    <>
                                        <div
                                          type="button"
                                          className={`block-accordion__header__btn ${isFirst ? "disabled" : ""}`}
                                          onClick={(e) => {
                                              e.stopPropagation()
                                              onMoveUp()
                                          }}
                                          disabled={isFirst}
                                          >
                                          <i className="fas fa-caret-up icon-btn"></i>
                                        </div>
                                        <div
                                          type="button"
                                          className={`block-accordion__header__btn ${isLast ? "disabled" : ""}`}
                                          onClick={(e) => {
                                              e.stopPropagation()
                                              onMoveDown()
                                          }}
                                          disabled={isLast}
                                          >
                                          <i className="fas fa-caret-down icon-btn"></i>
                                        </div>
                                    </>
                                    )
                                }
                                {
                                    block.type && (
                                        <div
                                            type="button"
                                            className="block-accordion__header__btn"
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                onDelete()
                                            }}
                                        >
                                            <i className="fas fa-trash-alt icon-btn-trash"></i>
                                            Delete
                                        </div>
                                    )
                                }
                            </>
                          )
                        }
                  </div>
                </div>
              </AccordionHeader>
              <AccordionBody accordionId={blockId} className="block-accordion__body">
                <BlockEditor
                  blockId={`${block.id}-${index}`}
                  type={block.type}
                  data={block.data}
                  onChange={onChangeData}
                  editable={editable}
                />
              </AccordionBody>
            </AccordionItem>
          </Accordion>
        )}
    </>
  );
}
